export default function Footer() {
  return (
    <footer className="bg-[#FAF8F4] border-t border-black/5 pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16">
          <div className="md:col-span-5">
            <div className="font-display text-3xl tracking-[0.18em] text-[#111]">KIVO</div>
            <p className="mt-4 max-w-sm text-[15px] leading-relaxed text-[#555]">
              A lifestyle brand for people who believe small habits create better days.
            </p>
            <div className="mt-6 text-[11px] tracking-[0.3em] uppercase text-[#CBBBA0]">
              Original by Choice.
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.25em] uppercase text-[#555] mb-4">Explore</div>
            <ul className="space-y-2 text-[14px] text-[#111]">
              <li><a href="#collections" className="hover:text-[#CBBBA0] transition-colors">Collections</a></li>
              <li><a href="#ritual" className="hover:text-[#CBBBA0] transition-colors">The Ritual</a></li>
              <li><a href="#challenge" className="hover:text-[#CBBBA0] transition-colors">Hydration Challenge</a></li>
              <li><a href="#story" className="hover:text-[#CBBBA0] transition-colors">Brand Story</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.25em] uppercase text-[#555] mb-4">Reach Out</div>
            <ul className="space-y-2 text-[14px] text-[#111]">
              <li>hello@kivo.world</li>
              <li>Mon–Fri · 10–6 IST</li>
              <li className="pt-3 text-[#555]">
                For press, partnerships and early-access enquiries.
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8 border-t border-black/5 text-[12px] text-[#555]">
          <div>© {new Date().getFullYear()} KIVO. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-[#111]">Privacy</a>
            <a href="#" className="hover:text-[#111]">Terms</a>
            <a href="#" className="hover:text-[#111]">Instagram</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
